import instances from '../../Grid/instances';
import store from '../../../store';
import _load from './load';
var listeners = {
  onRefresh: []
};
document.addEventListener('data-grid-refresh-resolved', function (e) {
  var response = e.detail;
  var view = response.view;
  listeners.onRefresh.filter(function (listener) {
    if (listener.where.id === view.id) return true;
    return false;
  }).map(function (matchedListener) {
    return matchedListener.callback(response);
  });
}, false);
/**
 *
 * @param {import('data/types').DataGridWhereClause} [where] An object used to
 * identify grids currently on page and run batch operations like refresh
 */

var dataGridActions = function dataGridActions(where) {
  return {
    /**
     * Fetches data from the server and refreshes the grid.
     * */
    refresh: function refresh(options) {
      return instances.refresh(where, options);
    },
    onRefresh: function onRefresh(callback) {
      var listener = {
        where: where,
        callback: callback
      };
      listeners.onRefresh.push(listener);
      return function () {
        listeners.onRefresh.splice(listeners.onRefresh.indexOf(listener), 1);
      };
    },
    load: function load(options) {
      return store.dispatch(_load(options));
    }
  };
};

export default dataGridActions;